module.exports = __webpack_public_path__ + "img/about_5.1dc178e7.png";